import React, {PropTypes} from 'react';
import Component from 'react-pure-render/component';
import {Col, Row} from 'react-bootstrap/lib/';
import objectAssign from 'object-assign';

import {
  nodeToJs,
  composeItemData,
  createTextInput
} from './utils';

export default class TextInputsGroup extends Component {
  static propTypes = {
    updateAction: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired,
    heading: PropTypes.string.isRequired,
    subheading: PropTypes.string,
    note: PropTypes.string,
    field: PropTypes.string.isRequired,
    value: PropTypes.object.isRequired,
    url: PropTypes.string,
    xs: PropTypes.number.isRequired,
    sm: PropTypes.number
  }

  onTextInputChange(event) {
    const {updateAction, value, field} = this.props;
    const {target: {name, value: inputValue}} = event;
    const v = objectAssign({}, value);

    v[name] = inputValue;


    updateAction({target: {name: field, value: v}});
  }

  render() {
    const {
      children,
      heading,
      subheading,
      note,
      value,
      xs,
      sm
    } = this.props;

    if (value === null || value === undefined) {
      throw new Error(`Checkboxes:error missing value`);
    }
    const inputUpdateAction = this.onTextInputChange.bind(this);

    const items = children
      .map(nodeToJs)
      .map(composeItemData({action: inputUpdateAction, value}));

    const textInputs = items
      .map(createTextInput);


    return (
      <Col xs={xs} sm={sm}>
        <Row>
          <Col xs={12}>
            <h3>{heading}</h3>
          </Col>
          {note && <Col className="group-note" xs={12}>{note}</Col>}
          {subheading && <Col className="group-note" xs={12}>{subheading}</Col>}
          <Col xs={12} className="form-inline">
            {textInputs}
          </Col>
        </Row>
      </Col>
    );
  }
}
